/**
 * Selection styling constants for consistent appearance across aircraft list components.
 * Used in: TimelineAircraftList, TimelineAircraftListItem, CurrentAircraft, AircraftListItem
 *
 * These are hex opacity suffixes (00-FF) appended to theme colors.
 * 35 = ~21% opacity, 45 = ~27% opacity
 */
export const SELECTION_OPACITY = {
  /** Background opacity for selected items */
  selected: "35",
  /** Background opacity for hover state on selected/hoverable items */
  hover: "45",
} as const;

/**
 * Helper to create a selection background color string.
 * @param themeColor - The theme color (e.g., theme.palette.success.main)
 * @param opacity - The opacity key from SELECTION_OPACITY
 * @returns Color string like "#4caf5025"
 */
export const getSelectionBgColor = (
  themeColor: string,
  opacity: keyof typeof SELECTION_OPACITY
): string => `${themeColor}${SELECTION_OPACITY[opacity]}`;
